export const Home = {
    Title: {
        '置顶课程': '置顶课程',
        '待办事项': '待办事项',
        '其他课程': '其他课程',
        '我教的':'我教的',
        '我协助的':'我协助的',
        '我学的':'我学的',
    },
    Handle: {
        '课堂排序': '课堂排序',
        '归档管理': '归档管理',
        '创建加入课程': '创建/加入课程',
        '创建课程': '创建课程',
        '编辑课程':'编辑课程',
        '加入课程': '加入课程',
        '查看全部': '查看全部',
        '从示范包创建':'从示范包创建',
        '资料': '资料',
        '忽略': '忽略',
        '已忽略':'已忽略!',
        '个人作业': '个人作业',
        '份作业待批改': '份作业待批改',
        '点击查看更多': '点击查看更多',
        '收起更多学期':'收起更多学期 ↑',
        '展开更多学期':'展开更多学期 ↓',
    },
    Classroom:{
        "直播中":"直播中",
        "会议上课中":"会议/上课中",
        "上课中":"上课中",
        "会议中":"会议中",
        "您有":"您有",
        "个课堂正在上课":"个课堂正在上课…",
    },
    "首页":"首页",
    "待办":"待办",
    "待办事项":"待办事项",
    "课堂":"课堂",
    "私信":"私信",
    "我的":"我的",
    "发现":"发现",
    "期末突击课":"期末突击课",
    "不挂科":"不挂科",
    "期末不挂科":"期末不挂科",
    "正在跳转中":"正在跳转中...",
    "登录中":"登录中...",
    "待审核":"待审核",
    "已通过":"已通过",
    "已拒绝":"已拒绝",
    "提交报名":"提交报名",
    "报名信息":"报名信息",
    "拒绝":"拒绝",
    "通过":"通过",
    "选择加入的标签":"选择加入的标签",
    "课程名称":"课程名称",
    "立即报名":"立即报名",
    "已报名审核中":"已报名，审核中",
    "您无法重复加入课程":"您无法重复加入课程",
    "审核中":"审核中",
    "被拒绝":"被拒绝",
    "您的报名被拒绝如有疑问请与课程老师联络":"您的报名被拒绝，如有疑问，请与课程老师联络",
    "课堂派会根据选择的类型定制课程教学活动模块展示您可手动变更定制结果":"课堂派会根据选择的类型，定制课程教学活动模块展示，您可手动变更定制结果",
    "不使用模板":"不使用模板",
    "混合课程":"混合课程",
    "线下课程":"线下课程",
    "在线课程":"在线课程",
    "实验课":"实验课",
    "社会实践课":"社会实践课",
    "其他":"其他",
    "选择课程模板":"选择课程模板",
    "请输入课程介绍":"请输入课程介绍",
    "要创建":"要创建",
    "吗":"吗?",
    "开启您的轻松建课之旅":"开启您的轻松建课之旅。",
    "创建成功":"创建成功",
    "报名设置":"报名设置",
    "审核方式":"审核方式",
    "审核后自动加入标签":"审核后自动加入标签",
    "默认标签":"默认标签",
    "报名信息收集":"报名信息收集",
    "添加更多报名信息问题":"添加更多报名信息问题",
    "收集信息标题":"收集信息标题",
    "请输入标题":"请输入标题",
    "自动审核":"自动审核",
    "手动审核":"手动审核",
    "要恢复":"要恢复",
    "您":"您",
    "和您的学生":"和您的学生",
    "可以重新在此课程中互动":"可以重新在此课程中互动",
    "此课程会在课程首页上显示":"此课程会在课程首页上显示",
    "取消归档成功":"取消归档成功",
    "输入课堂的6位加课码":"输入课堂的6位加课码",
    "也可以使用微信扫一扫扫描课堂二维码加入":"也可以使用微信扫一扫扫描课堂二维码加入",
    "进入课程":"进入课程",
    "点击返回至首页":"点击返回至首页",
    "前往认证":"前往认证",
    "您在这个课程的任何信息或评论将被永久删除":"您在这个课程的任何信息或评论将被永久删除。",
    "警告此操作无法撤销":"警告: 此操作无法撤销",
    "继续操作或关闭":"继续操作或关闭",
    "您可以在我的归档课堂里面查看此课堂":"您可以在“我的-归档课堂“里面查看此课堂",
    "归档自己":"归档自己",
    "归档全班":"归档全班",
    "要复制":"要复制",
    "请输入新课程名称":"请输入新课程名称",
    "复制内容":"复制内容",
    "复制学员":"复制学员",
    "复制助教":"复制助教",
    "复制资料":"复制资料",
    "复制外链":"复制外链",
    "确定要转让":"确定要转让",
    "此课程的任何信息或评论将被永久转让":"此课程的任何信息或评论将被永久转让",
    "请输入转让老师的账号手机号邮箱":"请输入转让老师的账号/手机号/邮箱",
    "没有找到匹配的结果":"没有找到匹配的结果",
    "课程排序":"课程排序",
    "搜索我教的课程":"搜索我教的课程",
    "请输入登录密码验证":"请输入登录密码验证",
    "加课码已重置":"加课码已重置",
    "确定要删除":"确定要删除",
    "请按照提示输入":"请按照提示输入",
    "删除后数据将无法恢复":"删除后数据将无法恢复！",
    "确定删除":"确定删除",
    "再想想":"再想想",
    "要归档管理此课程吗":"要归档管理此课程吗",
    "成功":"成功",
    "课程":"课程",
    "确定要退课":"确定要退课",
    "确定复制":"确定复制",
    "请输入课程名":"请输入课程名",
    "归档成功":"归档成功",
    "删除失败":"删除失败",
    "请输入要转让的老师的账号":"请输入要转让的老师的账号",
    "转让成功":"转让成功",
    "搜索我学的课程":"搜索我学的课程",
    "前往绑定":"前往绑定",
    "已成功加入":"已成功加入",
    "课堂名称":"课堂名称",
    "请输入课堂名称":"请输入课堂名称",
    "教学班级名称":"教学班级名称",
    "请输入教学班级名称":"请输入教学班级名称",
    "选择学年":"选择学年",
    "选择学期":"选择学期",
    "更多信息":"更多信息",
    "请输入大于0的数":"请输入大于0的数",
    "请输入学时":"请输入学时",
    "请输入授课地点":"请输入授课地点",
    "对机构后台可见":"对机构后台可见",
    "确认":"确认",
    "姓名":"姓名",
    "手机":"手机",
    "学号":"学号",
    "工号":"工号",
    "学校":"学校",
    "公司":"公司",
    "第一学期":"第一学期",
    "第二学期":"第二学期",
    "请填写课程名称":"请填写课程名称",
    "请选择学年":"请选择学年",
    "请选择学期":"请选择学期",
    "编辑成功":"编辑成功",
    "创建":"创建",
    "学生需额外补充下列信息才能加入课堂":"学生需额外补充下列信息才能加入课堂",
    "自然班级":"自然班级",
    "入学年月":"入学年月",
    "新建课程": "新建课程",
    "我的课程":"我的课程",
    "课程广场":"课程广场",
    "我的特权":"我的特权",
    "查看全部待办":"查看全部待办",
    "暂无待办事项":"暂无待办事项",
    "玩转课堂派":"玩转课堂派",
    "推荐课程":"推荐课程",
    "课程筛选":"课程筛选",
    "请选择课程":"请选择课程",
    "选择课程":"选择课程",
    "全部课程":"全部课程",
    "教":"教",
    "学":"学",
    "已经全部加载完了，没有更多了":"已经全部加载完了，没有更多了",
    "最早":"最早",
    "共有":"共有",
    "后可参与评论":"后可参与评论",
    "申请加入虚拟教研室可以继续阅读和名师一起研讨引用优质的教学资源":"申请加入虚拟教研室可以继续阅读和名师一起研讨引用优质的教学资源",
    "去评论":"去评论",
    "活动详情":"活动详情",
    "编辑内容":"编辑内容",
    "教研室公告":"教研室公告",
    "请输入公告内容":"请输入公告内容",
    "暂无公告内容":"暂无公告内容",
    "公告内容不允许为空":"公告内容不允许为空！",
    "发送申请":"发送申请",
    "请先填写个人信息发送申请发起人审核通过后可以参与虚拟教研室的建设同时还享有":"请先填写个人信息，发送申请。发起人审核通过后可以 参与虚拟教研室的建设，同时还享有",
    "引用该教研室的资源和共建的样板课程参与培训研讨":"引用该教研室的资源和共建的样板课程，参与培训研讨",
    "职称":"职称",
    "请选择职称":"请选择职称",
    "申请成功":"申请成功",
    "暂无申请消息":"暂无申请消息",
    "申请时间":"申请时间：",
    "处理申请":"处理申请",
    "提交信息":"提交信息",
    "设置身份":"设置身份",
    "内容不允许为空":"内容不允许为空！",
    "引用样板课程新建课程":"引用样板课程新建课程",
    "教学班级":"教学班级",
    "点击选择学年":"点击选择学年",
    "点击选择学期":"点击选择学期",
    "引用内容":"引用内容",
    "成绩设置":"成绩设置",
    "引用到样板课程":"引用到样板课程",
    "教研室基本信息":"教研室基本信息",
    "教研室名称":"教研室名称",
    "教研室封面":"教研室封面",
    "建设范围":"建设范围",
    "建设内容":"建设内容",
    "发起单位":"发起单位",
    "教研室简介":"教研室简介",
    "教学主体及目标":"教学主体及目标",
    "教研主体类型":"教研主体类型",
    "学分":"学分：",
    "核心教材":"核心教材：",
    "专业名称":"专业名称",
    "专业级别":"专业级别",
    "专业简介":"专业简介",
    "请在PC端添加主题及目标":"请在PC端添加主题及目标",
    "课程列表":"课程列表",
    "专业列表":"专业列表",
    "教学研究改革主题":"教学研究改革主题",
    "教研室主题":"教研室主题",
    "该小节暂无内容":"该小节暂无内容",
    "请在PC端添加章节课程":"请在PC端添加章节课程",
    "引用到":"引用到",
    "已分配占比":"已分配占比",
    "总成绩":"总成绩",
    "整课被引用次数":"整课被引用次数",
    "引用课程内容到":"引用课程内容到…",
    "课程目录":"课程目录",
    "成绩设置考核方案":"成绩设置(考核方案)",
    "课程达成度":"课程达成度",
    "暂无试题":"暂无试题",
    "已经向该教研室的管理团队发起申请请耐心等待审核":"已经向该教研室的管理团队发起申请，请耐心等待审核",
    "查看详情需要加入教研室确认加入":"查看详情需要加入教研室，确认加入？",
    "最新活动":"最新活动",
    "更多":"更多",
    "人在讨论":"人在讨论",
    "全部动态":"全部动态",
    "赞了我的":"赞了我的",
    "研讨会议":"研讨会议",
    "样板课程":"样板课程",
    "个研讨":"个研讨",
    "个动态":"个动态",
    "个成员":"个成员",
    "我创建的":"我创建的",
    "我参与的":"我参与的",
    "按创建时间":"按创建时间",
    "按名称":"按名称",
    "回放":"回放",
    "图形验证码":"图形验证码",
    "短信验证码":"短信验证码",
    "发送验证码":"发送验证码",
}
